/*무료보험 프로모션 추가부분*/
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { landAxios } from '@Root/utils/landAxios'
import FetchResponse from '@Types/inner/FetchResponse'
import { FETCH_STATUS } from '@Root/contants'
import MyhouseMainHouseResponse from '@Types/entities/MyhouseMainHouseResponse'

export const fetchIsAppliedById = createAsyncThunk('/myhouse/promotion/isAppliedById', async () => {
  const whenBeforeCheckupTimeStamp = Number(localStorage.getItem('myhouse:promo:applied:checktime') || 0)

  // 로컬스토리지 이용한 30분 캐싱 - 개발기간내 10초 캐싱
  if (whenBeforeCheckupTimeStamp && Date.now() - whenBeforeCheckupTimeStamp < 1000 * 10) {
    // if (whenBeforeCheckupTimeStamp && Date.now() - whenBeforeCheckupTimeStamp < 1000 * 60 * 30) {
    // 캐싱기간 이내이면
    const storageSaved = localStorage.getItem('myhouse:promotion-applied')
    return storageSaved === 'Y'
  } else {
    // 캐싱기간 이후이면 fetch
    const isApplied = await (await landAxios.get(`/myhouse/insurance/isApplied`)).data
    localStorage.setItem('myhouse:promotion-applied', isApplied === true ? 'Y' : 'N')
    localStorage.setItem('myhouse:promo:applied:checktime', Date.now().toString())
    return isApplied
  }
})

export const fetchHouse = createAsyncThunk('/myhouse/promotion/getMyhouse/', async (myhouseNo: number) => {
  return await (await landAxios.get(`/myhouse/v2/${myhouseNo}`)).data
})

export const fetchIsPromotionCanceled = createAsyncThunk('myhouse/promotion/canceled', async (houseNo: number) => {
  return await (await landAxios.get(`/myhouse/insurance/isCanceled/${houseNo}`)).data
})

export type MyHousePromotionState = {
  isAppliedMember: boolean
  house: FetchResponse<MyhouseMainHouseResponse>
  isPromotionCanceled: boolean
}

export const initialState: MyHousePromotionState = {
  isAppliedMember: false,
  house: { fetchStatus: FETCH_STATUS.INITIAL },
  isPromotionCanceled: false,
} as MyHousePromotionState

const promotionSlice = createSlice({
  name: 'myhousePromotion',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchIsAppliedById.fulfilled.type]: (state: MyHousePromotionState, action: PayloadAction<boolean>) => {
      state.isAppliedMember = action.payload
    },
    [fetchIsAppliedById.pending.type]: (state: MyHousePromotionState) => {
      state.isAppliedMember = false
    },
    [fetchIsAppliedById.rejected.type]: (state: MyHousePromotionState) => {
      state.isAppliedMember = false
    },
    [fetchHouse.fulfilled.type]: (state: MyHousePromotionState, action: PayloadAction<MyhouseMainHouseResponse>) => {
      state.house = {
        ...action.payload,
        fetchStatus: FETCH_STATUS.SUCCESS,
      }
    },
    [fetchHouse.pending.type]: (state: MyHousePromotionState) => {
      state.house.fetchStatus = FETCH_STATUS.PENDING
    },
    [fetchHouse.rejected.type]: (state: MyHousePromotionState) => {
      state.house.fetchStatus = FETCH_STATUS.FAILURE
    },
    [fetchIsPromotionCanceled.fulfilled.type]: (state: MyHousePromotionState, action: PayloadAction<boolean>) => {
      state.isPromotionCanceled = action.payload
    },
    [fetchIsPromotionCanceled.pending.type]: (state: MyHousePromotionState) => {
      state.isPromotionCanceled = false
    },
    [fetchIsPromotionCanceled.rejected.type]: (state: MyHousePromotionState) => {
      state.isPromotionCanceled = false
    },
  },
})

export default promotionSlice.reducer
